import { FilterExprSchema } from '@hostingportal/schemas'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import '../../../modules/companies/register-panels'
import { RetentionPipelinePage } from '../../../modules/retention/retention-pipeline-page'
import { PANEL_TYPES } from '../../../shell/panel-state'

const opportunitySearchSchema = z.object({
  q: z.string().optional(),
  view: z.enum(['table', 'board']).optional(),
  sortField: z.string().optional(),
  sortDir: z.enum(['asc', 'desc']).optional(),
  filter: FilterExprSchema.optional(),
  quick: FilterExprSchema.optional(),
  panel: z.enum(PANEL_TYPES).optional(),
  panelId: z.string().optional(),
  panelMode: z.enum(['create']).optional(),
})

export const Route = createFileRoute('/_authed/retention/opportunities')({
  validateSearch: opportunitySearchSchema,
  component: OpportunitiesRoute,
})

function OpportunitiesRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate()
  return (
    <RetentionPipelinePage
      mode="opportunities"
      search={search}
      setSearch={(patch) =>
        navigate({
          to: '.',
          search: ((prev: Record<string, unknown>) => ({ ...prev, ...patch })) as never,
          replace: true,
        })
      }
    />
  )
}
